export const processTracingRow = tracingInfo => {
    tracingInfo.startDate *= 1000;
    tracingInfo.endDate *= 1000;
    tracingInfo.regDate *= 1000;
    return tracingInfo;
}

export const processTracingList = originalList => {
    return originalList.map(processTracingRow);
}